import { Link } from 'gatsby';
import React from 'react';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';

interface ILocalizedLink {
    to?: string | null;
    children: any;
    className?: string;
    state?: any;
    onClick?: () => void;
}

export default function LocalizedLink({
    to,
    children,
    className = ``,
    onClick,
    ...remainingProps
}: ILocalizedLink) {
    const { localizePath } = usePageLocalization();

    if (!to)
        return (
            <div className={className} {...remainingProps}>
                {children}
            </div>
        );

    const localizedPath = localizePath(to);
    return (
        <Link
            to={localizedPath}
            onClick={() => onClick && onClick()}
            className={className}
            {...remainingProps}
        >
            {children}
        </Link>
    );
}
